import React from 'react'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowLuxPlusNonMemberPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import Caption from 'components/Luxkit/Typography/Caption'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'

interface MappedProps {
  isLuxPlusEnabled: boolean;
}

interface Props extends MappedProps {
  totalPrice?: number;
  totalMemberPrice?: number;
  totalGrossPrice?: number;
  isFromPrice: boolean;
  ticketUnitLabel: string;
  size?: 'S' | 'L' | 'M';
  nonMemberPriceSize?: 'L' | 'M';
  discountMemberPercentage?: number;
}

function ExperienceTilePrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    isFromPrice,
    ticketUnitLabel,
    isLuxPlusEnabled,
    size = 'S',
    nonMemberPriceSize = 'M',
    discountMemberPercentage,
  } = props

  if (isLuxPlusEnabled && totalMemberPrice) {
    return (
      <>
        {isFromPrice && <Caption
          as="span"
          colour="neutral-two"
          weight="normal"
          format="propercase"
          variant="large"
        >
          From
        </Caption>}
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size={size}
          memberPrice={totalMemberPrice}
          saleUnit="total"
        />
        {!!totalPrice && (
          <PriceRowLuxPlusNonMemberPrice
            size={nonMemberPriceSize}
            nonMemberPrice={totalPrice}
          />
        )}
        {!!totalGrossPrice && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size={nonMemberPriceSize}
          discountPercentage={discountMemberPercentage}
          discountType={isFromPrice ? 'estimate' : 'exact'}
        />}
      </>
    )
  }

  if (!totalPrice) return null

  return (
    <>
      {isFromPrice && <PriceRowPriceCaption>From</PriceRowPriceCaption>}
      <PriceRowPrice
        size={size}
        price={totalPrice}
        saleUnit={isFromPrice ? ticketUnitLabel : 'total'}
      />
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isLuxPlusEnabled: getIsEnabledLuxPlusDiscountedExperiences(state),
  }
}

export default connect(mapStateToProps)(ExperienceTilePrices)
